import { IframeLayout } from '@karakuri-web/faq-type'

interface Props {
  layout: IframeLayout
}
export function IframeWidget({ layout }: Props) {
  return layout.data ? <iframe className={'faq-iframe'} src={layout.data} /> : null
}
